var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui container"},[_c('h1',[_vm._v(" You are logged in successfully ")]),_c('button',{staticClass:"ui button",on:{"click":_vm.getDashboard}},[_vm._v("Continue to Dashboard")])])}
var staticRenderFns = []

export { render, staticRenderFns }